module.exports = __webpack_public_path__ + "img/shrine.39c80d10.svg";